import Vue from 'vue';
import abstractStore from '../../store/abstractstore';
import FirmengruppeService from '@/app/firmengruppe/firmengruppe.service';
import * as _ from 'lodash';

export const getDefaultSort = () => ({ currentSort: 'bezeichnung', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    id: null,
    bezeichnung: null,
    kunden: [],
    kundenString: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    ...abstractStore.getDefaultStore(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const firmengruppe = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
        updateKundenString(state, data) {
            Vue.set(state, data);
        },
    },
    actions: {
        clear({ commit }) {
            commit('clear');
        },
        updateKundenString(context, client_data) {
            context.commit('updateKundenString', client_data);
        },
        async create(context, client_data) {
            const { data } = await FirmengruppeService.create(client_data);
            context.commit('update', data);
        },
        async get(context, id) {
            const { data } = await FirmengruppeService.get(id);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await FirmengruppeService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await FirmengruppeService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            data.forEach((fg) => {
                let kundenString = '';
                fg.kunden.forEach((kunde) => {
                    kundenString += kunde.bezeichnung + ', ';
                });
                fg.kundenString = kundenString.slice(0, -2);
            });

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await FirmengruppeService.delete(slug);
        },
    },
    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default _.merge(firmengruppe, abstractStore.getDefaultStore());
